<button>
    <div id="container">
        <mat-icon svgIcon="organization"></mat-icon>
        {{ name }}
    </div>
</button>
